import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { useParams } from 'next/navigation';
import Countdown from 'react-countdown';
import { TestGrid } from './styles';
import useIsMobile from 'hooks/useIsMobile';

const TestBanner = ({ name = '' }) => {
  const isMobile = useIsMobile();
  const params = useParams();
  const slug = params?.slug?.[0];

  // end of day of Jan 19, 2025 EST time based on user local time
  const dateFuture = new Date('2025-01-20T05:00:00Z');

  const addSToText = (number, text) => {
    return number === 1 ? `${number} ${text}` : `${number} ${text}s`;
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return 0;
    }

    // Render a countdown
    return (
      <Typography variant={isMobile ? 'p2Medium' : 'h6'}>
        {addSToText(days, 'day')} {addSToText(hours, 'hour')} {addSToText(minutes, 'minute')}{' '}
        {addSToText(seconds, 'second')} to the deadline!
      </Typography>
    );
  };

  const renderText = () => {
    if (slug === 'wondertiktok') {
      return <Countdown date={dateFuture} renderer={renderer} />;
    }

    return (
      <Typography variant={isMobile ? 'p2Medium' : 'h6'}>
        {name} is taking reservations for a possible, upcoming round. Indicate interest today.
      </Typography>
    );
  };

  return (
    <TestGrid
      sx={{
        zIndex: 999,
      }}
      data-cy="test-banner"
    >
      {renderText()}
    </TestGrid>
  );
};
export default TestBanner;

TestBanner.propTypes = {
  name: PropTypes.string,
  // title: PropTypes.string,
};
